module.exports = __webpack_public_path__ + "static/media/DataScienceEthics.dde2c992.png";